import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Grid } from '@mui/material';
import Modal from '../../../../ui/layout/Modal';
import {
  addFailureData,
  editFailureData,
} from '../../../../modules/executions';
import { useNotification } from '../../../../hooks/NotificationContext';
import CustomSelect from '../../../../ui/primitives/CustomSelect';
import CustomInputField from '../../../../ui/primitives/CustomInputField';

const categories = ['Applications', 'Automation'];

const subCategoryOptions = {
  Applications: [
    { id: 'Bug', name: 'Bug' },
    { id: 'Slowness', name: 'Slowness' },
    { id: 'App Crash', name: 'App Crash' },
    { id: 'Infrastructure Error', name: 'Infrastructure Error' },
  ],
  Automation: [
    { id: 'Coding error', name: 'Coding error' },
    { id: 'Locator change', name: 'Locator change' },
    { id: 'Synchronization issue', name: 'Synchronization issue' },
    { id: 'Functional change not updated', name: 'Functional change not updated' },
    { id: 'Test data not available', name: 'Test data not available' },
  ],
};

const categoryOptions = categories.map((c) => ({ id: c, name: c }));

const AddEditFailure = ({
  show,
  handleClose,
  fetchData,
  testCaseId,
  executionId,
  loading,
  mode,
  selectedItem,
}) => {
  const { addNotification } = useNotification();

  const defaultData = {
    category: selectedItem?.category || 'Applications',
    subCategory: selectedItem?.sub_category || '',
    description: selectedItem?.description || '',
  };

  const [formData, setFormData] = useState(defaultData);

  useEffect(() => {
    setFormData({
      category: selectedItem?.category || 'Applications',
      subCategory: selectedItem?.sub_category || '',
      description: selectedItem?.description || '',
    });
  }, [selectedItem]);

  const handleCategoryChange = (value) => {
    setFormData({ ...formData, category: value, subCategory: '' });
  };

  const handleSubCategoryChange = (value) => {
    setFormData({ ...formData, subCategory: value });
  };

  const handleDescriptionChange = (_, value) => {
    setFormData({ ...formData, description: value });
  };

  const createFailureRecord = async () => {
    const failureData = {
      failure: {
        ...formData,
        testCaseId,
        executionId,
      },
    };
    try {
      mode === 'add'
        ? await addFailureData(failureData)
        : await editFailureData(failureData, selectedItem?.id);
      fetchData();
      addNotification(
        'success',
        `Item ${mode === 'add' ? 'added' : 'updated'} successfully`,
      );
      handleClose();
    } catch (error) {
      addNotification(
        'error',
        error.message ||
          `Failed to ${mode === 'add' ? 'add' : 'update'} item. Please try again`,
      );
    }
  };

  return (
    <Modal
      open={show}
      width="md"
      handleClose={handleClose}
      modalTitle={mode === 'add' ? 'Add Analysis' : 'Edit Analysis'}
      action={() => (
        <>
          <Button
            variant="outlined"
            color="secondary"
            onClick={handleClose}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={createFailureRecord}
            disabled={loading}
            startIcon={
              loading ? <CircularProgress size={16} color="inherit" /> : null
            }
          >
            Submit
          </Button>
        </>
      )}
    >
      <Box component="form" noValidate onSubmit={(e) => e.preventDefault()}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <CustomSelect
              id="category"
              label="Category"
              required
              value={formData.category}
              onChange={handleCategoryChange}
              options={categoryOptions}
              placeholder="Select category"
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <CustomSelect
              id="subCategory"
              label="Sub-Category"
              required
              value={formData.subCategory}
              onChange={handleSubCategoryChange}
              options={subCategoryOptions[formData.category] || []}
              placeholder="Select sub-category"
            />
          </Grid>

          <Grid item xs={12}>
            <CustomInputField
              id="description"
              label="Description"
              value={formData.description}
              onChange={handleDescriptionChange}
              placeholder="Enter Description"
              multiline
              rows={3}
              maxLength={500}
            />
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default AddEditFailure;